// extracted by mini-css-extract-plugin
export var container = "Header-module--container--yBjyO";
export var logo = "Header-module--logo--m5asN";
export var pallot = "Header-module--pallot--JaPRD";
export var pallo = "Header-module--pallo--KGEvK";
export var topi = "Header-module--topi--0VWGN";